// Vapi call data caching utilities
// Separate cache for Vapi data since it's fetched per-call and can be cached longer

import { cache } from './cache';

interface VapiCallData {
  recordingUrl?: string;
  transcript?: string;
  duration?: number;
  status?: string;
  contactInfo?: {
    name?: string;
    phone?: string;
    email?: string;
    company?: string;
  };
}

// Vapi data can be cached longer since it doesn't change once the call is complete
const VAPI_CACHE_TTL = 30 * 60 * 1000; // 30 minutes

export function getCachedVapiCall(callId: string): VapiCallData | null {
  return cache.get(`vapi:call:${callId}`);
}

export function setCachedVapiCall(callId: string, data: VapiCallData): void {
  cache.set(`vapi:call:${callId}`, data, VAPI_CACHE_TTL);
}

export function deleteCachedVapiCall(callId: string): void {
  cache.delete(`vapi:call:${callId}`);
}

// Clear all vapi call caches
export function clearAllVapiCache(): void {
  cache.clearPrefix('vapi:call:');
}